import { createSlice } from "@reduxjs/toolkit";

const refreshSlice = createSlice({
  name: "refresh",
  initialState: {
    refreshTrigger: 0, // Counter jo increment hoga har refresh par
    isRefreshing: false,
  },
  reducers: {
    triggerRefresh: (state) => {
      state.refreshTrigger = state.refreshTrigger + 1;
      state.isRefreshing = true;
    },
    refreshComplete: (state) => {
      state.isRefreshing = false;
    },
  },
});

export const { triggerRefresh, refreshComplete } = refreshSlice.actions;
export default refreshSlice.reducer;

